export default __webpack_public_path__ + "static/media/slider5it.e50a2ac3.jpg";